import script from "./pwa-menu-panel-sidebar.vue.ts?vue&type=script&setup=true&lang=ts!=!../../../../node_modules/vue-loader/dist/index.js??ruleSet[0]!./pwa-menu-panel-sidebar.vue?vue&type=script&setup=true&lang=ts"
export * from "./pwa-menu-panel-sidebar.vue.ts?vue&type=script&setup=true&lang=ts!=!../../../../node_modules/vue-loader/dist/index.js??ruleSet[0]!./pwa-menu-panel-sidebar.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__